import React, { lazy } from 'react';

import { getTenant } from '../../../Utils/storageUtils';
import { TenantType } from '../../../Utils/types';
import { renderErrorScreen } from '../../..';

export const loadPBSpends = () => import('../../PaisaBazaar/Spends');
export const loadYBSpends = () => import('../../YesBank/Spends');
export const loadMFSpends = () => import('../../Mahindra/Spends');
export const loadAUSpends = () => import('../../AUBank/Spends');

const PBSpends = lazy(loadPBSpends);
const YBSpends = lazy(loadYBSpends);
const MFSpends = lazy(loadMFSpends);
const AUSpends = lazy(loadAUSpends);

type Props = {
  onBack: () => void;
  defaultTab: any;
};

const Spends: React.FC<Props> = ({ defaultTab, onBack }) => {
  const tenant = getTenant();

  switch (tenant) {
    case TenantType.PB:
      return <PBSpends />;
    case TenantType.AU:
      return <AUSpends />;
    case TenantType.YESBANK:
      return <YBSpends defaultTab={defaultTab} onBack={onBack} />;
    case TenantType.MAHINDRA:
      return <MFSpends />;
    default:
      return (
        <div>{renderErrorScreen({ error: `Invalid Tenant ${tenant}` })}</div>
      );
  }
};

export default Spends;
